import { FC, useMemo } from "react";
import Image from "next/image";
import { Container } from "@/components/ui/container";
import S from "./index.module.scss";
import { chapters } from "@/views/about/constants";

interface IBlock {
  activeChapterID: number;
  previousChapterID: number | null;
  isChanging: boolean;
}

const getChapter = (chapterID: number | null) => {
  if (chapterID === null) {
    return undefined;
  }

  return chapters.find(ch => ch.id === chapterID);
};

interface ChapterSlideProps {
  chapter: (typeof chapters)[number];
  state: "active" | "entering" | "exiting";
}

const ChapterSlide = ({ chapter, state }: ChapterSlideProps) => {
  return (
    <div className={S.infoWrapper} data-state={state}>
      <div className={S.textWrapper}>
        <h1 className={S.backgroundTitle}>{chapter.tags.description}</h1>
        <h1 className={S.title}>{chapter.main.title}</h1>
        <span className={S.description}>{chapter.main.description}</span>
      </div>
      <Image src={chapter.src} alt={chapter.tags.description} width={536} height={550} />
    </div>
  );
};

const Block: FC<IBlock> = ({ activeChapterID, previousChapterID, isChanging }) => {
  const activeChapter = useMemo(() => chapters.find(ch => ch.id === activeChapterID), [activeChapterID]);
  const previousChapter = useMemo(() => getChapter(previousChapterID), [previousChapterID]);

  if (activeChapter === undefined) {
    return null;
  }

  return (
    <Container>
      <div className={S.sliderStage} data-changing={isChanging}>
        {previousChapter !== undefined && <ChapterSlide chapter={previousChapter} state="exiting" />}
        <ChapterSlide chapter={activeChapter} state={isChanging ? "entering" : "active"} />
      </div>
    </Container>
  );
};

export default Block;
